module.exports = __webpack_public_path__ + "img/PLACE_NEGATIVO.41fb9b25.png";